import { InsuranceState } from '@typings/insurance';
import { ChipProps } from 'easyship-components';

export function getInsuranceStateChipColor(state?: InsuranceState): ChipProps['color'] {
  switch (state) {
    case 'self-insured':
      return 'green';

    case 'buyer-insured':
      return 'blue';

    case 'courier-insured':
    case 'fallback-courier':
      return 'yellow';

    case 'fallback-uninsured':
    case 'uninsured':
      return 'red';

    case 'lyoc-uninsured':
    default:
      return 'ink';
  }
}
